// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3PoSW","list":"BalanceDue_list__2Dwnc","listRow":"BalanceDue_listRow__27YHa","total":"BalanceDue_total__3a6BE"};